import { UseMutationOptions } from '@tanstack/react-query';

import { GenericFailure } from '@playq/services-shared';
import { TeamMemberData } from '@playq/services-teams';

import { services2 } from '/api/services2';
import { useEitherMutation } from '/api/service-hooks';

import { MemberPayloadType } from './types';

export const usePromoteMember = (
  options?: UseMutationOptions<TeamMemberData, GenericFailure | Error, MemberPayloadType>
) =>
  useEitherMutation(
    ({ appID, teamId, userId, env }) => services2.teamsLookupService.promoteMember(appID, teamId, userId, env),
    {
      ...options,
    }
  );
